import React, { Component } from 'react';
import Fetch from '../../utils/fetch';
import { settings } from '../../settings';
import Button from '../../components/buttons/Button';
import { NewOrderForm } from './NewOrderForm';
import './NewOrder.scss';
import {
  CreateNewOrder,
  DeliveryVerification,
  Error,
  ServiceBrand,
} from '../../types/orderTypes';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import { fetchAccounts } from '../../fetch/fetchUsers';
import { Account, AccountCategory } from '../../types/userTypes';

interface NewOrderState {
  order: CreateNewOrder;
  errors: Error[];
  accounts: Account[];
}

export async function postOrder(
  order: CreateNewOrder,
  setErrors: (error: Error[]) => void
) {
  const orderRequest = {
    ...order,
    origin: {
      ...order.origin,
      pickupWindows: [
        {
          start: dayjs(order.destination.deliveryWindow.start).format(),
          end: dayjs(order.destination.deliveryWindow.end).format(),
        },
      ],
    },
    destination: {
      ...order.destination,
      deliveryWindow: {
        start: dayjs(order.destination.deliveryWindow.start).format(),
        end: dayjs(order.destination.deliveryWindow.end).format(),
      },
    },
  };

  const response = await Fetch.post({
    url: `${settings.newApiUrl}/order/admin-create`,

    body: {
      orderRequest: orderRequest,
      senderAccountId: order.accountId,
    },
  });

  if (response.ok) {
    await Swal.fire({
      title: `Order is successfully created`,
      icon: 'info',
    });
    window.location.href = `/orders/${(await response.json()).orderId}`;
  } else {
    const resData = await response.json();
    setErrors(resData);
  }
}

const emptyOrder: CreateNewOrder = {
  origin: {
    name: '',
    address: {
      streetName: '',
      streetNumber: '',
      postalCode: '',
      city: '',
      country: '',
    },
    email: '',
    phoneCountryCode: '+47',
    phoneNumber: '',
    pickupWindows: [
      {
        start: new Date(),
        end: new Date(),
      },
    ],
  },
  destination: {
    name: '',
    address: {
      streetName: '',
      streetNumber: '',
      postalCode: '',
      city: '',
      country: '',
    },
    email: '',
    phoneCountryCode: '+47',
    phoneNumber: '',
    bestAvailableWindow: false,
    deliveryWindow: {
      start: new Date(),
      end: new Date(),
    },
    verifications: {
      requireSignature: false,
      minimumAgeCheck: null,
      deliveryVerification: DeliveryVerification.CONTACTLESS,
      confirmCustomerReceipt: false,
    },
  },
  parcels: [
    {
      description: 'Dispatch order',
      widthCm: 30,
      heightCm: 30,
      depthCm: 30,
      weightGrams: 6000,
      volume: 0,
    },
  ],
  product: 'delivery',
  courierInstructions: '',
  brand: ServiceBrand.PORTERBUDDY,
  accountId: undefined,
};

export default class NewOrder extends Component<any, NewOrderState> {
  constructor(props: any) {
    super(props);
    const newOrder = this.props.location?.state?.newOrder;
    console.log(this.props.location?.state);
    this.state = {
      order: newOrder || emptyOrder,
      errors: [],
      accounts: [],
    };
  }

  async componentDidMount() {
    const accounts = await fetchAccounts(AccountCategory.SENDER);
    this.setState({ accounts: accounts });
  }

  setErrors = (errors: Error[]) => {
    this.setState({
      errors,
    });
  };

  render(): JSX.Element {
    const { order, errors } = this.state;

    return (
      <div className="new-order">
        <div style={{ height: 10 }} />
        <h1>Create new order</h1>
        <div style={{ height: 10 }} />
        <NewOrderForm
          order={order}
          handleOrderUpdate={order => this.setState({ order: order })}
          accounts={this.state.accounts}
        />
        <Button
          onClick={() => postOrder(order, this.setErrors)}
          title="Submit"
        />
        {errors.length > 0 && (
          <div className="u-alert__error" style={{ marginTop: 10 }}>
            Warning
            {errors.map(error => (
              <div
                key={`${error.message}-${error.propertyPath}`}
                style={{ marginTop: 10 }}
              >
                <div style={{ fontWeight: 500 }}>{error.propertyPath}</div>
                <div>{error.message}</div>
              </div>
            ))}
          </div>
        )}
        <div style={{ height: 10 }} />
      </div>
    );
  }
}
